<div *ngIf="(deviceStatus.statusCode === statusTypes.printing && deviceStatus.reason !== printingReason.PREPARING_FOR_PRINT) && deviceJob" class="progressbar-box">
    <nb-progress-bar [value]="deviceJob.progress"
                     [status]="deviceStatus.statusCode === statusTypes.printing ? 'primary' : 'basic'"
                     size="small"
                     [attr.current-value]="deviceJob.progress"
                     [displayValue]="true">
    </nb-progress-bar>
    <div class="progressbar-box__additional-info">
        <div class="progressbar-box__additional-info--file-name">
            {{ deviceJob.fileName }}
        </div>
        <div class="progressbar-box__additional-info--left-time">
            <span *ngIf="!isCompleted">
                <span>{{ 'device.status.left-time' | translate }}: </span>
                <span *ngIf="deviceStatus.statusCode === statusTypes.printing" class="progressbar-box__additional-info--left-time__value">
                    <span *ngIf="(displayTime | secondsToDays) >=1">{{displayTime | secondsToDays}}d </span>
                    {{ displayTime * 1000 | date:'HH:mm:ss':'UTC' }}
                </span>
                <span *ngIf="deviceStatus.statusCode !== statusTypes.printing" class="progressbar-box__additional-info--left-time__value">
                    <span *ngIf="(deviceJob.totalPrintTime | secondsToDays) >=1">{{deviceJob.leftTime | secondsToDays}}d </span>
                    {{ deviceJob.leftTime * 1000 | date:'H:mm:ss':'UTC' }}
                </span>
            </span>
            <span *ngIf="isCompleted">
                <span>{{ 'device.status.total-time' | translate }}: </span>
                <span class="progressbar-box__additional-info--left-time__value">
                    <span *ngIf="(deviceJob.totalPrintTime | secondsToDays) >=1">{{deviceJob.totalPrintTime | secondsToDays}}d </span>
                    {{deviceJob.totalPrintTime * 1000 | date:'HH:mm:ss':'UTC' }}
                </span>
            </span>
        </div>
        <div style="clear: both"></div>
    </div>
</div>
